// extracted by mini-css-extract-plugin
module.exports = {"deliveryInfo":"deliveryInfo_deliveryInfo__3Y9kn","fieldBig":"deliveryInfo_fieldBig__GQsZ6","fieldMedium":"deliveryInfo_fieldMedium__3Unu7","notes":"deliveryInfo_notes__2RrEt"};